<template>
  <div>
    <multiple-charts category="SET-mini" :charts="results" />

    <br />

    <set-dti-chart
      v-if="has()"
      :questionnaire="getFromDiagnosis('questionnaire')"
      :state="getFromDiagnosis('state')"
      :city="getFromDiagnosis('city')"
      :charts="getFromDiagnosis('types')"
      :config="configForm"
      :insights="insights"
    />
  </div>
</template>

<script>
import MultipleCharts from '@/Indicators/Components/MultipleCharts'
import SetDtiChart from '@/Indicators/Components/SETChart'

export default {
  components: {
    MultipleCharts,
    SetDtiChart,
  },
  props: {
    index:      Number,
    indicators: Array,
    results:    Array,
    diagnosis:  Object,
    insights:   Array,
    configForm: Object,
  },
  methods: {
    has() {
      return Object.keys(this.diagnosis ?? {}).length !== 0
    },
    getFromDiagnosis(prop) {
      if (this.diagnosis) {
        return this.diagnosis[prop]
      }

      switch (prop) {
      case 'questionnaire':
      case 'state':
      case 'city':
        return ''

      case 'types':
        return {}
      }
    },
  },
}
</script>
